





































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BrandIcon extends Vue {
  @Prop()
  brand!: string

  mounted() {
    console.log('Created brand')

  }
}
